<template>
	<div class="form-group">
		<label
            v-if="formKey !== 'show_detail'"
            for="exampleInputEmail1"
            class="text-capitalize"
        >
            <small>{{ label }}</small>
        </label>
        <textarea
			v-if="formKey === 'pickup_location_address' || formKey === 'notes'"
            :value="data[formKey]"
			class="form-control"
			aria-describedby="emailHelp"
			:placeholder="`Enter ${formKey}`"
            @input="(event) => onChange(event, formKey, 'textarea')"
        />
        <InputCheckbox
            v-else-if="formKey === 'show_detail' || formKey === 'bump' || formKey === 'shipping_assurance'"
            :label="data[formKey].label"
            :checked="data[formKey].value"
            @on-change="(event) => onChange(event, formKey, 'checkbox')"
        />
		<multiselect
			v-else-if="formKey === 'paymentType' || formKey === 'paymentMethod' || formKey === 'province' || formKey === 'city' || formKey === 'subdistrict' || formKey === 'payment_method'"
			:value="data[formKey].value"
			:options="data[formKey].options"
			track-by="key"
			label="label"
			:hide-selected="false"
			:multiple="false"
			:taggable="false"
			:reset-after="false"
			:show-labels="false"
			:allow-empty="false"
			:loading="data[formKey].loader || false"
			:disabled="data[formKey].loader || false"
            @input="(event) => onChange(event, formKey, 'select')"
		/>
        <input
            v-else
            :value="data[formKey]"
            :type="type"
            class="form-control"
            :placeholder="`Enter ${label}`"
            @input="(event) => onChange(event, formKey, type)"
		/>
		<small v-if="errorMessage && errorMessage[formKey]" class="text-danger">
			{{ errorMessage[formKey] }}
		</small>
	</div>
</template>

<script>
import InputCheckbox from '@/components/InputCheckbox.vue';

export default {
	name: 'EditOrderForm',
	props: {
		formKey: {
			type: String,
			default: '',
		},
		form: {
			type: Object,
			default: () => ({}),
		},
		partKey: {
			type: String,
			default: '',
		},
		errorMessage: {
			type: Object,
			default: () => {},
		},
	},
	components: {
		InputCheckbox,
	},
	data() {
		return {
			data: {},
		};
	},
	computed: {
		type() {
			let type = 'text';
			if (this.formKey === 'email') {
				type = 'email';
			}
			if (this.formKey === 'shipping_cost' || this.formKey === 'other_cost' || this.formKey === 'quantity') {
				type = 'number';
			}
			return type;
		},
		label() {
			const strFormat = this.formKey.split('_').join(' ');
			return strFormat
				.replace(/([A-Z])/g, ' $1')
				.replace(/^./, char => char.toUpperCase())
				.trim();
		},


	},
	created() {
		if (this.form) {
			this.data = this.form;
		}
	},
	methods: {
		onChange(event, key, type) {
			let value = null;
			if (type === 'text' || type === 'textarea' || type === 'number') {
				value = event?.target?.value;
				this.data[key] = value;
			} else {
				value = event;
				this.data[key].value = value;
			}
			this.$emit('on-change', this.data, this.partKey, this.formKey);
		},
	},
};
</script>
